import { useState } from 'react';
import { type MessageKey, useT } from '../i18n';
import { Icon } from './icons';

/** Bump when the list changes, so players see it once more. */
const NEWS_ID = '2026-12-22';
const SEEN_KEY = 'am27.newsSeen';

/** What changed in this build, newest first (message keys: news.<item>, news.<item>.text). */
const ITEMS = [
  'motorwayOut',
  'trees',
  'maps',
  'airportCity',
  'playtestNotes',
  'languages',
  'menuFilms',
  'stealthJets',
  'jetSound',
  'legal',
  'playtest',
  'phoneHud',
  'mobile',
  'guestPlay',
  'oneRunway',
  'realHelicopters',
  'roadTunnels',
  'motorwayKit',
  'moreTypes',
  'roadsLight',
  'aircraftTypes',
  'balloons',
  'flypast',
  'advice',
  'sizes',
  'giants',
  'militaryTower',
  'delayAlerts',
  'boom',
  'tollIncome',
  'serviceTunnels',
  'tolls',
  'insulation',
  'militaryRoads',
  'look',
  'flyby',
  'sharp',
  'onTime',
  'apron',
  'snowmen',
  'weatherOutlook',
  'freeBrush',
  'buildSites',
  'album',
  'terminalSound',
  'engineSound',
  'rainbow',
  'celebrations',
  'specialLivery',
  'vipCarpet',
  'airshow',
  'spotterDeck',
  'fireworks',
  'waterSalute',
  'vip',
  'dailyGoals',
  'helicopters',
  'flightCard',
  'standsEasier',
  'smoother',
  'worldRanking',
  'winterOps',
  'achievements',
  'art',
  'weather',
  'lanes',
  'captain',
  'graphics',
  'contactStands',
  'motorwayLink',
  'viaduct',
  'serviceRoads',
  'roadJunctions',
  'parking',
  'deicePad',
  'spectator',
  'radio',
  'apronPlan',
  'trafficAi',
  'cinema',
  'settings',
  'academy',
  'hints',
  'atc',
  'military',
  'realPlanes',
  'realVehicles',
  'towns',
  'privateJets',
  'brush',
  'move',
  'nightFlights',
  'junctions',
  'lights',
  'tunnels',
  'tutorial',
  'desktop',
  'grass',
  'traffic',
  'fleet',
  'community',
  'accounts',
  'liveMenu',
  'yearReport',
  'market',
  'forecast',
  'pavement',
  'value',
  'demo',
  'transfers',
  'international',
  'charter',
  'seasons',
  'snow',
  'storm',
  'shifts',
  'wages',
  'noise',
  'facilities',
  'hotel',
  'rail',
  'office',
  'kitchen',
  'cargo',
  'airlines',
  'marketing',
  'coop',
  'night',
  'noiseMap',
  'largeMap',
] as const;

function seen(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) === NEWS_ID;
  } catch {
    return false;
  }
}

/** A one-time card on the title screen listing what is new since the last build. */
export function WhatsNew() {
  const t = useT();
  const [open, setOpen] = useState(() => !seen());
  if (!open) return null;
  const close = () => {
    try {
      localStorage.setItem(SEEN_KEY, NEWS_ID);
    } catch {
      // Private mode: it shows again next time, which is fine.
    }
    setOpen(false);
  };
  return (
    <div className="whats-new-backdrop">
      <section className="whats-new" role="dialog" aria-label={t('news.title')}>
        <header className="sheet-head">
          <h2>{t('news.title')}</h2>
          <button type="button" className="icon-btn" onClick={close} title={t('hud.close')}>
            <Icon name="close" size={16} />
          </button>
        </header>
        <ul className="whats-new-list">
          {ITEMS.map((item) => (
            <li key={item}>
              <strong>{t(`news.${item}` as MessageKey)}</strong>
              <span className="muted small">{t(`news.${item}.text` as MessageKey)}</span>
            </li>
          ))}
        </ul>
        <button type="button" className="btn primary" onClick={close}>
          {t('news.ok')}
        </button>
      </section>
    </div>
  );
}
